// extracted by mini-css-extract-plugin
module.exports = {"signupForm":"the-sign-up_signupForm_3KoC3","agreementLabel":"the-sign-up_agreementLabel_32DQF"};